import LeaveApproval from "./LeaveApproval";
export default LeaveApproval;